export default "__VITE_ASSET__CxPWNFrV__"